import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Row } from "react-bootstrap";
import ICalendarLink from "react-icalendar-link";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useEffect } from "react";
import moment from "moment";

import { EventActions, authActions } from "../../../../../redux/actions";
import { allSharedComponents } from "../../../../../shared";
import {
  Directions,
  timezoneConstants,
  translationConstants,
  viewPathConstants,
} from "../../../../../constants";
import {
  CommaSplitToTranslatedCommaJoined,
  dateToUTCWithTimezone,
  formatDateTimeRangeFromServer,
  getUserPayload,
  moveBack,
  serverFormatToMomentObject,
  toSingleDateStringIfEqual,
} from "../../../../../system";
import {
  ArrowLeftIcon,
  DirectionIcon,
  TimeIcon,
} from "../../../../../assets/images/icon";

const { CustomModal, DeleteModal } = allSharedComponents;

//-------initial gridstate
const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: "id != null",
};

const DetailEvent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userPayload = getUserPayload();

  const queryParameters = new URLSearchParams(window.location.search);
  const paramEventId = queryParameters.get("eventId");
  const isActive = location?.state?.isActive || false;
  const stateEventId = location?.state?.eventId;
  const eventId = paramEventId ? paramEventId : stateEventId;

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [eventToDelete, setEventToDelete] = useState("");
  const [city, setCity] = useState();

  const cities = useSelector((state) => state.LoginReducer.cities);
  const eventData = useSelector((state) => state.eventReducer.eventDataById);
  const isViewModalOpen = useSelector((state) => state.eventReducer.openModal);

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  useEffect(() => {
    dispatch(EventActions.getEventById(eventId));
  }, [eventId, isActive]);

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [dispatch, eventData]);

  useEffect(() => {
    const findCity = cities?.find((c) => c.id === eventData?.cityId);
    setCity(findCity);
  }, [cities, eventData]);

  const onCancelRegistration = (heading, row) => {
    setTitle(heading);
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_REGISTRATION)}`
    );
    setEventToDelete(row);
    dispatch(EventActions.toggleViewModal(!isViewModalOpen));
  };

  const cancelRegistration = (data) => {
    if (eventToDelete?.isPublicRegistrationAllowed) {
      dispatch(
        EventActions.cancelPublicEventRegistration(
          userPayload?.user?.id,
          initialGridState,
          eventToDelete?.id,
          () => {
            navigate(-1);
          }
        )
      );
    } else {
      dispatch(
        EventActions.cancelPrivateEventRegistration(
          userPayload?.user?.id,
          initialGridState,
          eventToDelete?.id,
          "",
          () => {
            navigate(-1);
          }
        )
      );
    }
    dispatch(EventActions.toggleViewModal(false));
  };

  const icsEvent = {
    title: eventData?.title,
    description: eventData?.description,
    startTime: moment(
      eventData?.startDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    endTime: moment(
      eventData?.endDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    location: `${eventData?.spotInfo?.spotName}`,
  };

  return (
    <div className="container px-2 px-md-4 pb-4">
      <div className="py-4">
        <span className="cursor-pointer px-1" onClick={moveBack}>
          <img src={ArrowLeftIcon} className="rotated-element" />
        </span>
      </div>
      {eventData && (
        <div className="container">
          <div className="py-2 pt-0 borderRadius-10 mb-2">
            <img
              src={eventData?.posters?.link}
              alt=""
              className="w-100 poster-style"
            />
          </div>

          <div className="row">
            <div className="col-12 col-md-12 col-lg-7 mb-3">
              <div className="d-flex flex-column gap-2">
                <h3 className="fw-bolder">
                  {direction === Directions.rtl
                    ? eventData?.arabicTitle
                      ? eventData?.arabicTitle
                      : eventData?.title
                    : eventData?.title}
                </h3>
                <h3 className="font-14">
                  {toSingleDateStringIfEqual(
                    eventData?.startDateString,
                    eventData?.endDateString
                  )}
                </h3>
                <div className="d-flex gap-2 align-items-center">
                  <img
                    alt="TimeIcon"
                    name="activityDate"
                    src={TimeIcon}
                  />
                  <p className="font-14">
                    {formatDateTimeRangeFromServer(
                      eventData?.startDateString,
                      eventData?.endDateString,
                      timezoneConstants.hourMinuteFormat
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-5 mb-3 mb-lg-0 d-flex  gap-md-3 gap-2 align-items-start justify-content-lg-end">
              <div className="d-flex align-items-center justify-content-between flex-column">
                {dateToUTCWithTimezone().isSameOrBefore(
                  serverFormatToMomentObject(eventData?.endDateString)
                ) && (
                  <div className="seatsAvailableCard-light h-120px px-md-4 px-3 py-4 flex-grow-1 gap-2">
                    {!isActive ? (
                      <Button
                        className="registration-invite-only m-0"
                        disabled={true}
                      >
                        {t(translationConstants.CANCELLED)}
                      </Button>
                    ) : dateToUTCWithTimezone().isSameOrBefore(
                        serverFormatToMomentObject(eventData?.startDateString)
                      ) ? (
                      <Button
                        className="btn-cancel-outline m-0"
                        onClick={() => {
                          onCancelRegistration(
                            translationConstants.CANCEL_REGISTRATION,
                            eventData
                          );
                        }}
                      >
                        {eventData?.isPublicRegistrationAllowed
                          ? t(translationConstants.CANCEL_REGISTRATION)
                          : t(translationConstants.CANCEL_INVITE)}
                      </Button>
                    ) : (
                      dateToUTCWithTimezone().isSameOrBefore(
                        serverFormatToMomentObject(eventData?.endDateString)
                      ) && (
                        <Button
                          className="registration-invite-only customBtnforCompetionInProgress m-0"
                          type="button"
                          disabled={true}
                        >
                          {t(translationConstants.EVENT_IN_PROGRESS)}
                        </Button>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="text-black">
              <Row>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.LOCATION)}:
                    </h5>
                  </div>
                  <div>
                    <a
                      href={
                        eventData?.spotInfo
                          ? undefined
                          : `https://maps.google.com/?q=${eventData?.lat},${eventData?.long}`
                      }
                      onClick={(e) => {
                        if (eventData?.spotInfo) {
                          e.preventDefault(); // Prevent default link behavior
                          navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
                            state: {
                              centerId: eventData?.spotInfo?.id,
                            },
                          });
                        }
                      }}
                      target="_blank"
                      className="font-16 center-card-view-detail-link d-flex gap-1 align-items-center"
                    >
                      <img src={DirectionIcon} alt="get directions icon" />
                      {direction === Directions.rtl
                        ? eventData?.spotInfo?.arabicSpotName ||
                          eventData?.spotInfo?.spotName
                        : eventData?.spotInfo?.spotName}
                      {direction === Directions.rtl
                        ? city?.arabicName || city?.name
                        : city?.name}
                    </a>
                  </div>
                </Col>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.maximum_participants)}
                    </h5>
                  </div>
                  <div>
                    <p className="font-16">
                      {eventData?.maximumParticipantsAllowed}
                    </p>
                  </div>
                </Col>
              </Row>

              <Col sm={12} md="auto">
                {eventData?.providedServices && (
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.services)}
                    </h5>
                    <p className="font-16 w-75">
                      {CommaSplitToTranslatedCommaJoined(
                        eventData?.providedServices,
                        t
                      )}
                    </p>
                  </div>
                )}
              </Col>

              {eventData?.description && (
                <div className="py-4 d-flex flex-column gap-2">
                  <h5 className="second-card-heading-text">
                    {t(translationConstants.DESCRIPTION)}
                  </h5>
                  <p className="second-card-description-text w-75 text-break ">
                    {direction === Directions.rtl
                      ? eventData?.arabicDescription
                        ? eventData?.arabicDescription
                        : eventData?.description
                      : eventData?.description}
                  </p>
                </div>
              )}

              <div className="mt-20px">
                {eventData?.isPublicRegistrationAllowed && (
                  <a
                    target="_blank"
                    disabled={true}
                    className="d-none font-14 underline center-card-view-detail-link approved-color cursor-not-allowed"
                  >
                    {t(translationConstants.VIEW_CANCELLATION_POLICY)}
                  </a>
                )}
                <div>
                  <span
                    target="_blank"
                    disabled={true}
                    className="font-14 center-card-view-detail-link approved-color"
                  >
                    <ICalendarLink event={icsEvent} filename={eventData?.title}>
                      {t(translationConstants.add_to_calendar)}
                    </ICalendarLink>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <CustomModal
            scrollable={true}
            size="md"
            setShow={onCancelRegistration}
            show={isViewModalOpen}
            customClass="view-user-modal"
          >
            <DeleteModal
              title={title}
              message={message}
              dataToDelete={eventToDelete}
              removeRowData={cancelRegistration}
              onCancel={() =>
                dispatch(EventActions.toggleViewModal(!isViewModalOpen))
              }
            />
          </CustomModal>
        </div>
      )}
    </div>
  );
};

export default DetailEvent;
